import api from '@/utils/http'

/**
 功能：首页统计
 time: 2025-13-01 17:13:44
 **/
export function getStaticData(data) {
    return api.post('/admin/Analyze/getStaticData', data)
}

/**
 功能：
 time: 2026/3/16 10:00
 **/
export function getHomeStaticLine() {
    return api.get('/admin/Analyze/getHomeStaticLine')
}

/**
 功能：
 time: 2026/3/16 10:18
 **/
export function getHomeStaticPie() {
    return api.get('/admin/Analyze/getHomeStaticPie')
}

/**
 功能：
 time: 2026/3/16 10:44
 **/
export function getHomeExpendBar() {
    return api.get('/admin/Analyze/getHomeExpendBar')
}

/**
 功能：
 time: 2026/3/16 10:44
 **/
export function getHomeExpenseBar() {
    return api.get('/admin/Analyze/getHomeExpenseBar')
}

/**
 功能：
 time: 2026/3/16 10:59
 **/
export function getHomeExpenseLine() {
    return api.get('/admin/Analyze/getHomeExpenseLine')
}

